import { useUserApi } from '../../app';
import { AccountsHelpers } from '../../domain/accounts';
import { OrganizationRouteController } from './organizationRouteInterface';
import { OrganizationRouteConfig } from './organizationRouteConfig';
import { useParams } from 'react-router-dom';
import { OrganizationRouteParams } from './organizationRouteSchema';
import { useMemo } from 'react';

export function createOrganizationRouteController(
    config: Pick<OrganizationRouteConfig, 'controller'>
): OrganizationRouteController {
    return {
        useProps(data) {
            const user = useUserApi();
            const dataset = config.controller.useVarosDataset();
            const workspaceUrl = user.getDefaultWorkspaceUrl();
            const workspace = user.getCurrentWorkspace();
            const reportsUrl = `/u/assets/${workspace?.id}/reports/summary`;

            const isAgency = useMemo(() => {
                if (data.profile.data) {
                    return AccountsHelpers.isAgency(data.profile.data);
                }
            }, [data.profile.data]);

            const params = useParams();

            // this is only safe because all the keys are optional
            const parsed = OrganizationRouteParams.parse(params);

            return {
                reportsUrl,
                workspaceUrl,
                homeUrl: parsed.workspaceId
                    ? `/u/assets/${parsed.workspaceId}/home`
                    : workspaceUrl,
                dashboardUrl: workspace
                    ? `/u/assets/${workspace.id}/dashboards`
                    : workspaceUrl,
                insightUrl: workspace
                    ? `/u/assets/${workspace.id}/opportunities`
                    : workspaceUrl,
                reportUrl: isAgency ? '/u/reports' : null,
                creativeCoOpUrl: `/u/private-groups`,
                researchUrl: `/u/research`,
                datasetAssetCount: dataset.assetCount ?? 0,
                isVisible(item) {
                    return true;
                },
                getLinkId(id: string) {
                    return `main_navigation_${id}`;
                },
            };
        },
    };
}
